import { Component } from '@angular/core';
import { TopNavService } from '../Top-Nav/topNav.service';

@Component({
    selector: 'onboarding-banner',
    template:
        '<span>There are new features! <a class="clickable" (click)="openModal()">Click</a> to learn more.</span>',
    imports: [],
})
export class OnboardingBannerComponent {
    constructor(private readonly _topNavService: TopNavService) {}

    async openModal(): Promise<void> {
        await this._topNavService.showOnboardingModal();
    }
}
